import { useContext, useRef } from 'react'
import { UltyModalWrapperContext } from '../../../../Shared/UltyModalWrapper/UltyModalWrapperContext'
import { StartPreparingScheduledOrderWarning } from '../../../OrdersScheduled/StartPreparingScheduledOrderWarning'


const useScheduledOrderPrecheck = (order) => {
    const { handleUltyModalWrapper } = useContext(UltyModalWrapperContext)
    // useRef to store whether the precheck has been passed to avoid showing the modal multiple times during the same session
    const precheckPassedRef = useRef(false)

    const needsPrecheck = () => {
        return order.isScheduledForLater && order.status !== 'PREPARING' && !precheckPassedRef.current
    }

    const withScheduledOrderPrecheck = (callback) => {
        return (...args) => {
            if (needsPrecheck()) {
                handleUltyModalWrapper(true, {
                    closeIcon: undefined,
                    component: <StartPreparingScheduledOrderWarning
                      order={order}
                      onSubmit={(haveConfirmed) => {
                          if (haveConfirmed) {
                              precheckPassedRef.current = true
                              callback(...args)
                          }
                          handleUltyModalWrapper(false, null)
                      }}
                    />,
                })
            } else {
                callback(...args)
            }
        }
    }

    return { withScheduledOrderPrecheck, needsPrecheck }
}

export { useScheduledOrderPrecheck }

